export default __webpack_public_path__ + "assets/enterprise-one-one.94b6463bcf5f1238f00b9bad314bf6c4.png";